import React, { useEffect, useState } from "react";
import { getOnlineRegistration } from '../Service/Api';
import { Link } from 'react-router-dom';

const OnlineReg = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const onlineData = await getOnlineRegistration();
        setData(onlineData);
      } catch (error) {
        console.error("Error fetching online registration data:", error);
      }
    };
    fetchData();
  }, []);

  const breakTitleAfterWords = (title, wordLimit = 5) => {
  if (!title) return { line1: "", line2: "" };

  const words = title.split(" ");

  if (words.length <= wordLimit) {
    return { line1: title, line2: "" };
  }

  return {
    line1: words.slice(0, wordLimit).join(" "),
    line2: words.slice(wordLimit).join(" "),
  };
};

  return (
    <>  
  {data && data.length > 0 ? (
  data.map((item, index) => {
    const { line1, line2 } = breakTitleAfterWords(item.title, 5);

    return (
      <div className="OnlineR" key={index}>
        <span className="bounce1">
          <Link
            to="https://entab.online/STBASIL"
            target="_blank"
            className="parantlogo"
          >
            {line1}
            {line2 && <><br />{line2}</>}
          </Link>

          {item.attachments?.length > 0 && (
            <Link
              to={`https://webapi.entab.info/api/image/${item.attachments[0]}`}
              target="_blank"
            >
              <i className="bi bi-paperclip"></i>
            </Link>
          )}
        </span>
      </div>
    );
  })
) : null}

    </>
  );
}

export default OnlineReg;

// import React from "react";
// import { Link } from "react-router-dom";

// const OnlineReg = () => {

//   // 🔒 Static data (picked only title & url)
//   const data = [
//     {
//       title: "CLICK HERE - ONLINE REGISTRATION FOR NUR & LKG 2026-27",
//       url: "https://entab.online/stbasil"
//     }
//   ];

//   const breakTitleAfterWords = (title, wordLimit = 5) => {
//     if (!title) return { line1: "", line2: "" };

//     const words = title.split(" ");

//     if (words.length <= wordLimit) {
//       return { line1: title, line2: "" };
//     }

//     return {
//       line1: words.slice(0, wordLimit).join(" "),
//       line2: words.slice(wordLimit).join(" "),
//     };
//   };

//   return (
//     <>
//       {data.map((item, index) => {
//         const { line1, line2 } = breakTitleAfterWords(item.title, 5);

//         return (
//           <div className="OnlineR" key={index}>
//             <span className="bounce1">
//               <Link
//                 to={item.url}
//                 target="_blank"
//                 className="parantlogo"
//               >
//                 {line1}
//                 {line2 && (
//                   <>
//                     <br />
//                     {line2}
//                   </>
//                 )}
//               </Link>
//             </span>
//           </div>
//         );
//       })}
//     </>
//   );
// };

// export default OnlineReg;
